import PersonOutlinedIcon from '@mui/icons-material/PersonOutlined'
import PeopleOutlinedIcon from '@mui/icons-material/PeopleOutlined'
import Diversity3OutlinedIcon from '@mui/icons-material/Diversity3Outlined'
import DevicesOutlinedIcon from '@mui/icons-material/DevicesOutlined'
import { IconProps, SvgIconTypeMap } from '@mui/material'
import { OverridableComponent } from '@mui/material/OverridableComponent'

export namespace ClassType {
  export class Enum {
    static readonly INDIVIDUAL = new Enum(1, 'INDIVIDUAL', 'Aula individual', PersonOutlinedIcon)

    static readonly GROUP = new Enum(2, 'GROUP', 'Aula em Grupo', PeopleOutlinedIcon)

    // id/name devem espelhar o ClassTypeEnum do backend — o endpoint /available-options
    // vincula o param `classType` via enum converter do Spring, esperando o NOME da constante
    // (ex: "PLATFORM"), não o id nem o displayName. Manter em sincronia ao adicionar novos tipos.
    static readonly INDIVIDUAL_GROUP = new Enum(
      3,
      'INDIVIDUAL_GROUP',
      'Individual + Grupo',
      Diversity3OutlinedIcon
    )

    static readonly PLATFORM = new Enum(4, 'PLATFORM', 'Plataforma', DevicesOutlinedIcon)

    public constructor(
      public readonly id: number,
      public readonly name: string,
      public readonly title: string,
      public readonly icon?: OverridableComponent<SvgIconTypeMap<object, 'svg'>>
    ) {}

    public get Icon() {
      return this.icon as React.ComponentType<IconProps>
    }
  }

  export const getByName = (name: string): Enum => {
    return Object.values(ClassType.Enum).find(type => type.name === name)
  }

  export const getById = (id: number | undefined): Enum | undefined => {
    return Object.values(ClassType.Enum).find(type => type.id === id)
  }
}
